import moment, { Moment } from 'moment';
import { getUnmaskedValue } from './InputMaskUtils';

export type ValidationModel = {
  error: boolean;
  helperText?: string;
};

export const DEFAULT_VALIDATION_MODEL = (error = false, helperText = '') => {
  return {
    error,
    helperText,
  };
};

export const DEFAULT_VALID = DEFAULT_VALIDATION_MODEL(false, '');

export const requiredIsValid = (value: any, messageError: string) => {
  if (
    typeof value === 'number' ||
    (typeof value === 'string' && value.trim().length > 0)
  ) {
    return {
      error: false,
    };
  } else if (typeof value === 'object') {
    return {
      error: Array.isArray(value) ? !value || !value.length : !value,
      helperText: messageError,
    };
  }
  return {
    error: true,
    helperText: messageError,
  };
};

export const hasAtLastOneValue = (
  values: any[],
  moreThan: number,
  messageError: string
) => {
  if (Array.isArray(values) && values! && values!?.length! > moreThan) {
    return {
      error: false,
    };
  }

  return {
    error: true,
    helperText: messageError,
  };
};

export const allIsTrue = (validations: boolean[]) => {
  return (
    validations.filter((item) => typeof item === 'boolean' && item === true)
      .length === validations.length
  );
};

export const allIsFalse = (validations: boolean[]) => {
  return (
    validations.filter((item) => typeof item === 'boolean' && item === false)
      .length === validations.length
  );
};

export const validaData = (data: string | Moment) => {
  if (!String(data).match(/\d{2}\/{1}\d{2}\/{1}\d{4}/)) return false;
  const mData = moment(data, 'DD/MM/YYYY');
  if (!mData.isValid()) return false;
  return true;
};

export const validaHora = (data: string) => {
  return String(data).match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/);
};

export const firstDateIsBefore = (firstDate: string, secondDate: string) => {
  const fd = moment(firstDate, 'DD/MM/YYYY');
  const sd = moment(secondDate, 'DD/MM/YYYY');
  return (
    secondDate &&
    secondDate.length &&
    validaData(firstDate) &&
    firstDate &&
    validaData(secondDate) &&
    firstDate.length &&
    fd.isBefore(sd)
  );
};

export const firstHourIsBefore = (firstHour: string, secondHour: string) => {
  const fd = moment(firstHour, 'HH:mm');
  const sd = moment(secondHour, 'HH:mm');
  return (
    secondHour &&
    secondHour.length &&
    validaHora(firstHour) &&
    firstHour &&
    validaHora(secondHour) &&
    firstHour.length &&
    fd.isBefore(sd)
  );
};

const cpfsInvalidos = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
];

export const matchYT = (url: string = '') => url.match(/youtu(\.){0,1}be/);
export const matchMicrosoftStream = (url: string = '') =>
  url.match(/(.*microsoftstream.com)(\/embed){0,1}\/video/);
export const matchVimeo = (url: string = '') =>
  url.match(/.*vimeo.com(\/video\/{0,1}){0,1}/);

export const validaCPF = (cpf: string) => {
  cpf = getUnmaskedValue(cpf);
  if (cpf.length !== 11 || cpfsInvalidos.indexOf(cpf) > -1) return false;
  // PRIMEIRO DIGITO
  let primeiraSoma = 0;
  for (let i = 0; i < 9; i++) {
    primeiraSoma += (10 - i) * parseInt(cpf[i]);
  }
  let primeiroResto = (primeiraSoma * 10) % 11;
  if (primeiroResto >= 10) primeiroResto = 0;
  if (primeiroResto !== parseInt(cpf[9])) return false;
  // SEGUNDO DIGITO
  let segundaSoma = 0;
  for (let i = 0; i < 10; i++) {
    segundaSoma += (11 - i) * parseInt(cpf[i]);
  }
  let segundoResto = (segundaSoma * 10) % 11;
  if (segundoResto >= 10) segundoResto = 0;
  if (segundoResto !== parseInt(cpf[10])) return false;
  return true;
};

export const validaCNPJ = (value: string) => {
  const cnpj = getUnmaskedValue(value);
  if (cnpj.length !== 14) return false;
  // Primeiro Dígito
  const firstMod =
    [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2].reduce((soma, atual, index) => {
      return soma + atual * parseInt(cnpj[index]);
    }, 0) % 11;
  const firstDigit = firstMod < 2 ? 0 : 11 - firstMod;
  if (firstDigit !== parseInt(cnpj[12])) return false;
  // Segundo Dígito
  const secondMod =
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2].reduce((soma, atual, index) => {
      return soma + atual * parseInt(cnpj[index]);
    }, 0) % 11;
  const secondDigit = secondMod < 2 ? 0 : 11 - secondMod;
  if (secondDigit !== parseInt(cnpj[13])) return false;
  return true;
};
